import { connect } from "react-redux";
import get from "lodash/get";

import {
  addLogisticTripRoute as onAddLogisticTripRoute,
  deleteLogisticTripRoute as onDeleteLogisticTripRoute,
  updateLogisticTripRouteAlarm as onUpdateLogisticTripRouteAlarm,
} from "./../../actions/logisticTripRoutesActions";

const mapStateToProps = (state) => ({
  logisticAddTripRouteDataState: state.logisticTripRoutes.logisticAddTripRouteDataState,
  logisticDeleteTripRouteDataState: state.logisticTripRoutes.logisticDeleteTripRouteDataState,
  logisticUpdateTripRouteAlarmDataState: state.logisticTripRoutes.logisticUpdateTripRouteAlarmDataState,
  errors: get(state, ["logisticTripRoutes", "errors"], []),
});

const mapDispatchToProps = {
  onAddLogisticTripRoute,
  onDeleteLogisticTripRoute,
  onUpdateLogisticTripRouteAlarm,
};

const withLogisticTripRoutes = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticTripRoutes };
